import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import BottomNav from './BottomNav';
import NotificationBell from './NotificationBell';

export default function Layout({ title, backTo, backLabel, maxWidth = '7xl', showBottomNav = true, onBack, children }) {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isSubPage = !!backTo || !!onBack;

  return (
    <div className="min-h-screen bg-snow">
      {/* 헤더+콘텐츠를 하나의 전환 단위로 묶어 함께 슬라이드 */}
      <div style={{ viewTransitionName: 'page-content' }}>
        <header className="bg-white/80 backdrop-blur-lg sticky top-0 z-40 border-b border-border pt-[env(safe-area-inset-top)]">
          <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
            {isSubPage ? (
              <button
                onClick={onBack || (() => navigate(backTo))}
                className="text-tayo hover:text-tayo-dark font-medium flex items-center gap-1"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
                {backLabel || '뒤로'}
              </button>
            ) : (
              <h1 className="text-xl font-bold text-charcoal">{title}</h1>
            )}

            {isSubPage && (
              <h1 className="text-lg font-bold text-charcoal">{title}</h1>
            )}

            {!isSubPage ? (
              <div className="flex items-center gap-2">
                <NotificationBell />
                <button
                  onClick={handleLogout}
                  className="text-sm text-sub-text hover:text-coral transition-colors"
                >
                  로그아웃
                </button>
              </div>
            ) : (
              <div className="w-16" />
            )}
          </div>
        </header>

        <main className={`max-w-${maxWidth} mx-auto px-4 py-6 ${showBottomNav ? 'pb-24' : ''}`}>
          {children}
        </main>
      </div>

      {showBottomNav && <BottomNav />}
    </div>
  );
}
